export default __webpack_public_path__ + "static/media/KOD0060-min.1da9cbe9.webp";